import { Page } from '@/payload/payload-types';

type SpacerProps = {
	size: '24' | '48' | '64' | '80' | '96' | '240';
};

export const Spacer: React.FC<SpacerProps> = ({ size }) => {
	const sizes = {
		24: 'h-6', // 24px
		48: 'h-8 lg:h-12', // 32px/48px
		64: 'h-10 lg:h-16', // 40px/64px
		80: 'h-10 lg:h-20', // 40px/80px
		96: 'h-12 lg:h-24', // 48px/96px
		240: 'h-20 lg:h-60', // 80px/240px
	};

	return <div className={sizes[size]} />;
};
